const globalNav = [
    {
        type: 'link',
        value: 'Home',
        href: '/',
        icon: 'home'
    },
    {
        type: 'link',
        value: 'Fixtures',
        href: '/fixtures',
        icon: 'today',
        takesParams: true
    },
    {
        type: 'dropbar',
        value: 'Stats',
        icon: 'assessment',
        dropBar: [
            {
                heading: 'Batting',
                items: [
                    { value: 'Batting Averages', href: '/batting-averages', takesParams: true },
                    { value: 'Batting Records', href: '/batting-records', takesParams: true },
                    { value: 'Best Seasons', href: '/batting-seasons', takesParams: true },
                    { value: 'The Run Chase', href: '/batting-run-chase', takesParams: true },
                    { value: 'The 87 Trophy', href: '/batting-87-trophy', takesParams: true }
                ]
            },
            {
                heading: 'Bowling',
                items: [
                    { value: 'Bowling Averages', href: '/bowling-averages', takesParams: true },
                    { value: 'Bowling Records', href: '/bowling-records', takesParams: true },
                    { value: 'Best Seasons', href: '/bowling-seasons', takesParams: true },
                    { value: 'The Wicket Chase', href: '/bowling-wicket-chase', takesParams: true }
                ]
            },
            {
                heading: 'Fielding',
                items: [{ value: 'Fielding Records', href: '/fielding-records', takesParams: true }]
            },
            {
                heading: 'Other',
                items: [
                    { value: 'Double Acts', href: '/double-acts', takesParams: true },
                    { value: 'The Jug League', href: '/jug-league', takesParams: true }
                ]
            }
        ]
    },
    {
        type: 'dropbar',
        value: 'Info',
        icon: 'info',
        dropBar: [
            {
                items: [
                    { value: 'Players', href: '/players' },
                    { value: 'Awards', href: '/awards' },
                    { value: 'League Tables', href: '/league-tables' }
                ]
            },
            {
                items: [{ value: '50 Club', href: '/50-club' }]
            },
            {
                items: [
                    { value: 'About', href: '/about' },
                    { value: 'Location', href: '/location' },
                    { value: 'Contact Us', href: '/contact' }
                ]
            }
        ]
    },
    {
        type: 'link',
        value: 'Photos',
        href: '/photos',
        icon: 'camera'
    }
];

const GlobalNavStore = {
    getGlobalNav() {
        return globalNav;
    }
};

export default GlobalNavStore;



// WEBPACK FOOTER //
// ./src/stores/GlobalNavStore.js